import { BoxConfigRefType } from '@profile/src/utils/types';
export const getSkinInfo = (skin, config) => {
  const cosmetic = skin.data[BoxConfigRefType.COSMETIC];

  if (cosmetic && config.cosmeticConfigs) {
    return {
      name: cosmetic.name,
      skinName: '',
      image: config.cosmeticConfigs[cosmetic.typeId].urlImage
    };
  }

  const hero = skin.data[BoxConfigRefType.HERO_SKIN];

  if (hero) {
    return {
      name: hero.heroInfo.name,
      skinName: hero.skinInfo.name,
      image: hero.skinInfo.imageFull
    };
  }

  return {
    image: '',
    name: '',
    skinName: ''
  };
};